module.exports = __webpack_public_path__ + "static/media/cerrajero.3a3379fe.svg";